import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {
  ISimpleSelectableData,
  ISimpleSelectableDataList
} from '../model/interface/simple-selectable-data.model.interface';
import {FormBuilder, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DialogOpener} from "../utils/dialog-opener";
import {HtmlViewerComponent} from "../html-viewer/html-viewer.component";
import {AbstractControlComponent} from "../abstract-control-value-accessor/abstract-control.component";
import {MatFormFieldAppearance} from "@angular/material/form-field";

@Component({
  selector: 'app-simple-select-value-accessor',
  templateUrl: './simple-select-value-accessor.component.html',
  styleUrls: ['./simple-select-value-accessor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SimpleSelectValueAccessorComponent),
      multi: true,
    },
  ],
})
export class SimpleSelectValueAccessorComponent extends AbstractControlComponent {
  @Input() required = false;
  @Input() label: string;
  @Input() data: ISimpleSelectableDataList;
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Output() selected = new EventEmitter();

  selectFormControl: FormControl;

  constructor(private formBuilder: FormBuilder,
              private _dialogOpener: DialogOpener) {
    super();
    this.createForm();
    this.emitValueOnChange();
  }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.selectFormControl.valueChanges.subscribe(fn);
  }


  writeValue(value: any): void {
    if (value === null) {
      this.selectFormControl.reset();
    } else {
      this.selectFormControl.setValue(value);
    }
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.selectFormControl.disable() : this.selectFormControl.enable();
  }

  compareWith(first: number, second: number): boolean {
    if (!first || !second) {
      return false;
    }
    return first === second;
  }

  get orderedData() {
    return this.data?.data.sort((s1, s2) => s1.label.localeCompare(s2.label));
  }

  private createForm() {
    this.selectFormControl = this.formBuilder.control({});
  }

  clear() {
    this.selectFormControl.reset();
  }

  private emitValueOnChange() {
    this.selectFormControl.valueChanges
      .subscribe(value => this.selected.emit(value));
  }

  peek(instance: ISimpleSelectableData) {
      this._dialogOpener.open(HtmlViewerComponent, {data: instance.tooltip})
  }
}
